<template>
    <div class="temaryPage">
        <transition name="slide-left">
            <div v-if="course">
                <nav-bar v-show="isMenuOpen || window.width > 600" :course="course" :theme="themeObj"
                          v-on:nodeClick="changeTheme"></nav-bar>
            </div>
        </transition>

        <transition name="fade">
            <content-data
                v-if="content && course"
                :content="content"
                :breadcrumb="breadcrumb"
                :course="course"
                :finished="finished"
                :next-theme="nextTheme"
                :previous-theme="previousTheme"
                @changeTheme="changeTheme"
                @updateBreadcrumb="getBreadcrumb"
                @finish="finish"
            ></content-data>
        </transition>

    </div>
</template>
<script>
    import Vue from 'vue'
    import navBar from "./elements/navBar";
    import contentData from "./elements/contentData";
    import {mapState} from 'vuex'
    // import VModal from 'vue-js-modal'
    //
    // Vue.use(VModal)
    let msgServer;
    export default {
        name: 'temary',
        computed: {
            themeString(){
                if (!this.theme) return null;
                return this.theme.toString();

            },
            nextTheme() {
                if (!this.theme) return null;
                let theme = this.course.themes.findIndex((c) => {
                    return c.data.slug == this.theme
                });
                if (theme >= 0) {
                    if (this.course.themes[theme + 1]) {
                        return this.course.themes[theme + 1];
                    }
                }
                return null;
            },
            previousTheme() {
                if (!this.theme) return null;

                let theme = this.course.themes.findIndex((c) => {
                    return c.data.slug == this.theme
                });
                if (theme >= 0) {
                    if (this.course.themes[theme - 1]) {
                        return this.course.themes[theme - 1];
                    }
                }
                return null;
            },
            ...mapState(['isMenuOpen', 'courses','user'])
        },
        watch:{
            '$route.params.slug': function (newVal) {
                this.theme = newVal;
                this.checkSessionEmail();
                this.getContent(this.theme);
                // this.getThemeObj()

            },
            // theme: function (newVal) {
            //     console.log(newVal)
            //     // this.breadcrumbs = [];
            //     // this.getBreadcrumbsArray();
            //
            // }
        },
        components: {
            navBar,
            contentData
        },
        data() {
            return {
                course: null,
                theme: null,
                themeObj: {},
                content: null,
                index: {},
                breadcrumb: [],
                window: {
                    width: 0,
                    height: 0
                },
                finished: false
            }
        },
        beforeMount() {
            this.checkSessionEmail();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        mounted() {
            this.getCourse(this.$route.params.courseSlug);

            // (async () => {
            //     try {
            //         // Store SSE object at a higher scope
            //         msgServer = await this.$sse('https://oniad.com/user/5', { format: 'json' }); // omit for no format pre-processing
            //
            //         // Catch any errors (ie. lost connections, etc.)
            //         msgServer.onError(e => {
            //             console.error('lost connection; giving up!', e);
            //
            //             // If you don't want SSE to automatically reconnect (if possible),
            //             // then uncomment the following line:
            //             // msgServer.close();
            //         });
            //
            //         // Listen for messages without a specified event
            //         msgServer.subscribe('', data => {
            //             console.warn('Received a message w/o an event!', data);
            //         });
            //
            //         // Listen for messages based on their event (in this case, "chat")
            //         msgServer.subscribe('chat', message => {
            //             console.log(message)
            //             // this.messages.push(message);
            //         });
            //
            //         // Unsubscribes from event-less messages after 7 seconds
            //         setTimeout(() => {
            //             msgServer.unsubscribe('');
            //
            //             console.log('Stopped listening to event-less messages!');
            //         }, 7000);
            //
            //         // Unsubscribes from chat messages after 7 seconds
            //         setTimeout(() => {
            //             msgServer.unsubscribe('chat');
            //
            //             console.log('Stopped listening to chat messages');
            //         }, 14000);
            //     } catch (err) {
            //         // When this error is caught, it means the initial connection to the
            //         // events server failed.  No automatic attempts to reconnect will be made.
            //         console.error('Failed to connect to server', err);
            //     }
            // })();
        },
        beforeDestroy() {
            // Make sure to close the connection with the events server
            // when the component is destroyed, or we'll have ghost connections!
            // msgServer.close();
        },
        methods: {
            checkSessionEmail(){
                let u = Vue.$sessionStorage.get('user',null);
                if (u){
                    this.$store.state.user = u;
                }else{
                    this.$router.push({name: 'home'});
                }
            },
            finish(){
                this.finished = true;
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            buildIndex(root, children) {
                for(let i in children) {
                    this.index[children[i].data.slug] = root;
                    this.buildIndex(children[i].data.slug, children[i].children);
                }
            },
            getBreadcrumb(){
                // this.breadcrumb = [];
                this.buildIndex("Root", this.course.nav);

                this.breadcrumb  = this.getPath(this.theme);
                this.breadcrumb.shift()

            },
            getPath(leaf) {
                return this.index[leaf] ? this.getPath(this.index[leaf]).concat([leaf]) : [leaf];
            },
            changeNode(){

            },
            //Recupera el contenido del tema
            getContent(t) {
                this.$store.dispatch({type: 'getContentData', slug: t}).then((content)=>{
                    if (content !== false){
                        this.content = content;
                        this.getBreadcrumb();
                        this.getThemeObj();
                    }else{
                    }
                    this.backToTop();
                });
            },
            //Obtiene los cursos pero no se usa
            // getCourses() {
            //     this.$store.dispatch({type: 'getCourses'});
            // },

            //Obtiene info del curso y setea el tema segun la url o el primero por defecto
            getCourse(courseSlug) {
                this.$store.dispatch({type: 'getCourse', slug: courseSlug}).then((r) => {
                    this.course = r;
                    if (!this.$route.params.slug) {
                        this.theme = this.course.nav[0].data.slug;
                        this.$route.params.slug = this.theme
                        // this.changeTheme(this.course.nav[0]);
                    } else {
                        this.theme = this.$route.params.slug;
                    }
                    // this.getBreadcrumb();
                    this.getContent(this.theme);
                })
            },
            //Sirve para cambiar de  tema y refrescar el contenido
            changeTheme(theme) {
                this.finished = false;
                this.$router.push({name: 'temary', params: {id: this.course.id, slug: theme.data.slug}});

            },
            getThemeObj(){
                this.$store.dispatch({type:'getTheme',slug:this.theme}).then((a)=>{this.themeObj = a;})
            },
            backToTop () {
                window.smoothscroll();
                // this.$emit('scrolled')
            }
        }

    }
</script>
<style lang="scss">

</style>